import { Api, ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutLoadBoardTruckSearchSlideout } from "./autogen/AutogenLayoutLoadBoardTruckSearchSlideout";
import { DataDisplayEvent, DataSourceMode, Table } from "@mcleod/components";

export class LoadBoardTruckSearchSlideout extends AutogenLayoutLoadBoardTruckSearchSlideout {

    private associatedUserTable: Table;

    override async onLoad() {
    }
    
    
    async postDataSources(): Promise<boolean> {
        try {
            if (this.mainDataSource.data[0].originalData === undefined) {
                this.mainDataSource.activeRow.set("service_type", "T");
                this.mainDataSource.activeRow.set("posting_format", "T");
                this.mainDataSource.activeRow.set("method", "H");
                this.mainDataSource.activeRow.set("is_active", "Y"); 
            }

            await this.mainDataSource.post();
            await this.sourcePnnTranscoreUser.post();
            return true;
        } catch {
            return false;
        }
    }

}
